import { GetStampDto, UploadStampsDto } from '../autogenerated/spdApiClient';
import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';

export type StampEntity = GetStampDto;

export interface StampContextInterface {
  getStampsByUser: (userId?: string) => Promise<GetStampDto[]>;
  uploadStamps: (
    uploadStampsDto: UploadStampsDto,
    userId?: string,
  ) => Promise<GetStampDto[]>;
}

export const StampContext = (api: DefaultApi) => {
  return {
    getStampsByUser: async (userId?: string) => {
      return await api.stampControllerGetStampsByUser(userId);
    },
    uploadStamps: async (uploadStampsDto: UploadStampsDto, userId?: string) => {
      return await api.stampControllerUploadStamps(uploadStampsDto, userId);
    },
  };
};
